import axios from 'axios';
import store from '../redux/store/store';
const API_USER_URL = import.meta.env.VITE_API_URL;

const profileService = {
  getProfile: (authUserId,token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const authUserIdParam = authUserId;
    return axios.get(`${API_USER_URL}/User`, {
      params: { id: authUserIdParam }  ,
      headers: {
        Authorization: `Bearer ${userToken}`,},
    });
  },



  updateProfile: (userData,token) => {
    userData.id=userData.userId;
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.put(`${API_USER_URL}/User`, userData,{   
      headers: {
      Authorization: `Bearer ${userToken}`,},
  });
  },

//KOD GÖNDER
sendCondePasswordApi: (data,token) => {
  const userEmail = data.email;
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  return axios.post(`${API_USER_URL}/Email/change-Password`, 
    JSON.stringify(userEmail), 
    {
      headers: {
        'Content-Type': 'application/json' ,
        Authorization: `Bearer ${userToken}`,
      }
    }
  );
},


//ŞİFRE GÜCELLE
changePasswordApi: (data,token) => {

  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  return axios.put(`${API_USER_URL}/User/ChangePassword`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }
  });
},


forgotPasswordService: (data) => {

  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  return axios.put(`${API_USER_URL}/User/ForgotPassword`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }
  });
},
};




export default profileService;
